// extracted by css-extract-rspack-plugin
export default {"select_dealer_wrap":"aR0hBmTZhgwr0QLk","deaelers_container":"lmKSVds4DRokbyy6","dealer_name":"mBa0YgKyShAzpd71","dealer_form_select":"LzzWbQqDGRgRpzEC"};